/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-font-color',
  templateUrl: './theme-option-tooltips-title-font-color.component.html',
  styleUrls: ['./theme-option-tooltips-title-font-color.component.css']
})
export class ThemeOptionTooltipsTitleFontColorComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleFontColor';

  constructor() {}
  
  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_titleFontColor', value);
  }

}
